<template>
  <app-page-container title="گزارش کدها در شیفت">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="1" class="mr-n3">
        <v-btn class="mx-2 mt-3" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
          <v-icon dark>mdi-filter mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1" class="mr-n3 mt-6" v-if="isSearch">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()" class="">
              mdi-filter-remove mdi-18px
            </v-icon>
          </template>
          <span>حذف فیلتر ها</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="1" class="mt-3">
        <v-btn @click="
          exportToExcel(tableHeader, tableItems, 'text', `phone_activity_report_page_${page}`)
          " fab dark small color="darkColor" elevation="0">
          <v-icon dark>mdi-file-excel mdi-18px</v-icon>
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main">
        <v-col cols="12" class="pa-0">
          <v-card elevation="0" class="card-width body-card pa-0">
            <v-card-text class="pa-0">
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <template>
                    <v-data-table fixed-header hide-default-header :headers="tableHeader" :items="tableItems"
                      :page.sync="page" :items-per-page="tableItems.length" height="67vh" :search="searchTitle"
                      :hide-default-footer="true" multi-sort class="elevation-0 tt">
                      <template v-slot:header="props">
                        <app-group-table-header :headers="props.props.headers" @sort="props.on.sort"
                          @group="props.on.group" />
                      </template>
                      <template v-slot:[`item.icon`]="{ item }">
                        <v-icon color="#2EBA7F" class="ml-2">{{ item.icon }}</v-icon>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon @click="goToDetail(item.id)" class="ml-2">
                          mdi-account-switch mdi-18px
                        </v-icon>
                      </template>

                      <template v-slot:no-data>
                        <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                      </template>
                    </v-data-table>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <pagination-component ref="pagination">
            <div slot="action">
              <v-card elevation="0">
                <v-pagination class="mt-8" circle v-model="page" color="lightColor" :length="totalPages"
                  :total-visible="8" :value="totalPages" prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"
                  @next="next()" @previous="previous()" @input="input()"></v-pagination>
              </v-card>
            </div>
          </pagination-component>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
      </section>
      <section>
        <v-dialog width="450" v-model="searchModal">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-magnify</v-icon>
                  <span class="modal-title-text mr-2">جستجو</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-5">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete :items="allPhonesForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                    clear-icon="mdi-close-circle-outline" item-text="code" item-value="id" label="کد"
                    v-model="searchPhoneId" autocomplete="off" prepend-inner-icon="mdi-phone mdi-flip-h mdi-18px"
                    style="font-size: 11px !important"></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-autocomplete :items="allCitysForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined clearable
                    clear-icon="mdi-close-circle-outline" item-text="title" item-value="id" label="شهر"
                    v-model="searchCityId" autocomplete="off" prepend-inner-icon="mdi-home-city mdi-18px"
                    style="font-size: 11px !important"></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-autocomplete :items="allVehicleTypesForOther" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                    clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                    label="نوع وسیله نقلیه" v-model="searchVehicleTypeId" autocomplete="off"
                    prepend-inner-icon="mdi-ambulance mdi-18px" style="font-size: 11px !important"></v-autocomplete>
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-text-field type="text" outlined id="user-moveFromStationTime" ref="moveFromStationTime" dense
                    clearable autocomplete="off" @click:clear="clearDateTime('searchFromDate')"
                    clear-icon="mdi-close-circle-outline" v-model="tempSearchFromDate"
                    @focus="showSearchFromDate = true" @click="showSearchFromDate = true" label="از تاریخ"
                    prepend-inner-icon="mdi-calendar-range mdi-18px">
                    <template slot="append">
                      <v-icon @click="showSearchFromDate = true" class="calender-background ml-n3 mt-n2" color="white">
                        mdi-calendar-range mdi-18px
                      </v-icon>
                    </template>
                  </v-text-field>
                  <date-picker :show="showSearchFromDate" simple v-model="searchFromDate" type="datetime" @open="onOpen"
                    @change="dateTimeChange('searchFromDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                    display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#moveFromStationTime-moveFromStationTime"
                    @close="showSearchFromDate = false" />
                </v-col>
                <v-col cols="12" class="mt-n5">
                  <v-text-field type="text" outlined id="user-arriveToLocationTime" ref="arriveToLocationTime" dense
                    autocomplete="off" clearable @click:clear="clearDateTime('searchToDate')"
                    clear-icon="mdi-close-circle-outline" v-model="tempSearchToDate" @focus="showSearchToDate = true"
                    @click="showSearchToDate = true" label="تا تاریخ" prepend-inner-icon="mdi-calendar-range mdi-18px">
                    <template slot="append">
                      <v-icon @click="showSearchToDate = true" class="calender-background ml-n3 mt-n2" color="white">
                        mdi-calendar-range mdi-18px
                      </v-icon>
                    </template>
                  </v-text-field>
                  <date-picker :show="showSearchToDate" simple type="datetime" @open="onOpen" v-model="searchToDate"
                    @change="dateTimeChange('searchToDate')" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                    display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#arriveToLocationTime-arriveToLocationTime"
                    @close="showSearchToDate = false" />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
                جستجو
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </section>
    </template>
  </app-page-container>
</template>
<script>
import AlertComponent from '@/components/AlertComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';
import AppGroupTableHeader from '@/components/app/table/groupableHeader.vue';

import ExcelHelper from '@/Helpers/Excel.generator.helper';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import CodeActivityReportHelper from '@/Helpers/Report/Amar/CodeActivityReportHelper.js';
import ReportMixin from '@/Mixins/Report/ReportMixin.js';
import CityMixin from '@/Mixins/BaseInformation/CityMixin.js';
import PhoneMixin from '@/Mixins/BaseInformation/PhoneMixin';
import VehicleTypeMixin from '@/Mixins/BaseInformation/VehicleTypeMixin.js';
export default {
  name: 'amarCodeReport',
  title: 'گزارش کدها در شیفت',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    PaginationComponent,
    AppPageContainer,
    AppGroupTableHeader,
  },
  mixins: [
    pagination,
    ShearedMixin,
    ReportMixin,
    CodeActivityReportHelper,
    snackBar,
    ShearedHelper,
    VehicleTypeMixin,
    PhoneMixin,
    CityMixin,
    ExcelHelper,
  ],
  created() {
    this.$root.$refs.AmarCodeReport = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.setPreTimes();
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getAmarCodeReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchPhoneId,
        this.searchCityId,
        this.searchVehicleTypeId,
        this.page,
        this.pageSize,
      );
      this.getListOfPhonesForOther();
      this.getListOfCitysForOther();
      this.getListOfVehicleTypesForOther();
    },
    previous: function () {
      this.getAmarCodeReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchPhoneId,
        this.searchCityId,
        this.searchVehicleTypeId,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getAmarCodeReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchPhoneId,
        this.searchCityId,
        this.searchVehicleTypeId,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getAmarCodeReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchPhoneId,
        this.searchCityId,
        this.searchVehicleTypeId,
        this.page,
        this.pageSize,
      );
      this.$refs.pagination.page = this.page;
    },
  },
  computed: {},
};
</script>
<style scoped lang="scss">
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

.calender-background {
  background: #79747e;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 12px;
  padding-bottom: 12px;
  border-top-left-radius: 5px !important;
  border-bottom-left-radius: 5px !important;
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}
</style>
